export const testimonials = [
  {
    id: 1,
    name: "Dr. Priya Sharma",
    country: "India → Australia",
    exam: "ADC Part 2",
    text: "ODA gave me the confidence and precision I needed. The mock exams were exactly like the real thing. I passed on my first attempt!",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. Ahmed Khan",
    country: "Pakistan → Australia",
    exam: "ADC Part 2",
    text: "The structured approach and continuous feedback helped me identify my weak areas. The faculty is incredibly supportive and experienced.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Sarah Thompson",
    country: "UK → Canada",
    exam: "NDECC",
    text: "Best decision I made for my NDECC preparation. The hands-on training and realistic simulation gave me the edge I needed.",
    rating: 5
  },
  {
    id: 4,
    name: "Dr. Rajesh Patel",
    country: "India → USA",
    exam: "US Bench Test",
    text: "The attention to detail and rubric-based teaching at ODA is exceptional. They prepare you not just to pass, but to excel.",
    rating: 5
  },
  {
    id: 5,
    name: "Dr. Maria Garcia",
    country: "Spain → Ireland",
    exam: "Irish Dental Council",
    text: "I trained at ODA for 5 weeks and it completely transformed my clinical skills. The infrastructure and training methodology are world-class.",
    rating: 5
  },
  {
    id: 6,
    name: "Dr. Vikram Singh",
    country: "India → Australia",
    exam: "ADC Part 2",
    text: "From 18 students in the first batch to over 1000 now - ODA's reputation speaks for itself. Ethical, professional, and results-driven.",
    rating: 5
  },
  {
    id: 7,
    name: "Dr. Emily Chen",
    country: "Malaysia → Australia",
    exam: "ADC Part 2",
    text: "The daily practice schedule and continuous assessment pushed me to improve every single day. Highly recommend ODA!",
    rating: 5
  },
  {
    id: 8,
    name: "Dr. Mohammed Ali",
    country: "Egypt → Canada",
    exam: "NDECC",
    text: "ODA's focus on exam simulation and time management was crucial for my success. The feedback after each mock was invaluable.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is the duration of the courses?",
    answer: "Our flagship ADC Part 2 course is 5 weeks of intensive full-time training (Monday-Friday: 10 AM – 7 PM, Saturday: 10 AM – 2 PM). Other courses like NDECC, Irish Dental Council, and US Bench Test have similar structured durations. Contact us for specific course timelines."
  },
  {
    id: 2,
    question: "Do you provide training materials and equipment?",
    answer: "Yes! We provide all necessary training materials, manikins, instruments, and supplies. Our facility is equipped with state-of-the-art simulation setups including CPR manikins, LA manikins, radiograph equipment, and complete clinical stations."
  },
  {
    id: 3,
    question: "Is accommodation available?",
    answer: "While we don't provide in-house accommodation, we assist students in finding comfortable and affordable housing near our facility in Chandigarh. The city is student-friendly with plenty of PG, hostel, and apartment options."
  },
  {
    id: 4,
    question: "Do you offer mock exams?",
    answer: "Absolutely! Mock exams are a core part of our training. We conduct 3-5 comprehensive mock examinations that replicate real exam conditions. Each mock is followed by detailed feedback and rubric-based evaluation to help you improve."
  },
  {
    id: 5,
    question: "Can I extend my course duration?",
    answer: "Yes, course extensions are possible based on your progress and needs. We offer flexible options to ensure you feel fully prepared before your actual exam. Please discuss this with our team during enrollment."
  },
  {
    id: 6,
    question: "Who can apply for these courses?",
    answer: "Our courses are designed for qualified dentists (BDS/DDS or equivalent) who are preparing for international licensing exams like ADC Part 2, NDECC, Irish Dental Council, or US Bench Test. We welcome students from all countries."
  },
  {
    id: 7,
    question: "Where exactly is ODA located?",
    answer: "We are located at SCO 224-225, Sector 40D, Chandigarh, India. Chandigarh is well-connected by air, rail, and road. The city is clean, planned, safe, and offers an excellent environment for focused preparation."
  },
  {
    id: 8,
    question: "What is your success rate?",
    answer: "We are proud of our high success rate. From our very first batch of 18 students where 17 passed, we've maintained excellent results across 1000+ trained dentists. Our reputation is built on results, not marketing."
  },
  {
    id: 9,
    question: "What makes ODA different from other training centers?",
    answer: "Our approach is ethical, structured, and simulation-focused. We provide continuous feedback, rubric-based teaching, realistic exam environments, and personalized attention. We expect discipline and commitment from students, and we deliver world-class training in return."
  },
  {
    id: 10,
    question: "How do I enroll?",
    answer: "You can reach out to us via phone/WhatsApp at +91 9914637377 or email us at enquiries@overseasdentalachievers.co.in. You can also fill out the course enquiry form on our website, and our team will get back to you with enrollment details."
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "Simulation Lab",
    description: "State-of-the-art clinical training facility",
    category: "facility",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/tho1t1s2_Stimulation.png"
  },
  {
    id: 2,
    title: "Hands-on Training",
    description: "Students practicing clinical procedures",
    category: "training",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/mflambn0_1%20on%201%20interaction%201.png"
  },
  {
    id: 3,
    title: "Mock Examination",
    description: "Real exam simulation environment",
    category: "training",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/n62h961z_Mock12.webp"
  },
  {
    id: 4,
    title: "Infection Control",
    description: "Professional dental equipment and manikins",
    category: "facility",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/vl3fs2u3_Infection%20control%202.png"
  },
  {
    id: 5,
    title: "Group Session",
    description: "Interactive learning and demonstrations",
    category: "training",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/uxdqpnut_image.png"
  },
  {
    id: 6,
    title: "Clinical Practice",
    description: "Students working on restorative procedures",
    category: "training",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/2vbd56el_Clinical%20Practice.jpg"
  },
  {
    id: 7,
    title: "Training Room",
    description: "Spacious and well-equipped learning environment",
    category: "facility",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/3c3fodgx_Training%20Room.jpg"
  },
  {
    id: 8,
    title: "One-on-One Guidance",
    description: "Personalized feedback and mentoring",
    category: "training",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/x25u9l9r_10skilled%20mocks.webp"
  },
  {
    id: 9,
    title: "OSCE Practice",
    description: "Skilled OSCE station training",
    category: "training",
    imageUrl: "https://customer-assets-lxgj4vgw.emergentagent.net/job_oda-courses/artifacts/wr4vfaih_OSCE%20STIMULATION.png"
  }
];

export const courses = [
  {
    id: "adc-part-2",
    title: "ADC Part 2 Practical",
    shortDesc: "Comprehensive training for Australian Dental Council Part 2 Practical Examination",
    duration: "35 days (30 working days)",
    mode: "Full-time",
    popular: true
  },
  {
    id: "ndecc",
    title: "NDECC",
    shortDesc: "National Dental Examining Committee of Canada certification preparation",
    duration: "5 weeks",
    mode: "Full-time",
    popular: false
  },
  {
    id: "irish-dental",
    title: "Irish Dental Council",
    shortDesc: "Training for Irish Dental Council licensing examination",
    duration: "4-5 weeks",
    mode: "Full-time",
    popular: false
  },
  {
    id: "us-bench-test",
    title: "US Bench Test",
    shortDesc: "Preparation for US dental licensing bench test examination",
    duration: "3-4 weeks",
    mode: "Full-time",
    popular: false
  }
];

export const highlights = [
  {
    id: 1,
    number: "1000+",
    label: "Dentists Trained",
    icon: "users"
  },
  {
    id: 3,
    number: "13+",
    label: "Years of Excellence",
    icon: "award"
  },
  {
    id: 4,
    number: "25+",
    label: "Countries Represented",
    icon: "globe"
  }
];
